$(document).on("turbolinks:load", function () {

  if($('#js-field-type-select').is('*')){
    $('#js-field-type-select').on('change', function(){
      filterDataTypeSelect();
    });

    $('#js-data-type-select').on('change', function(){
      displayOptions();
    });
  }

});

function filterDataTypeSelect() {
  var value = $('#js-field-type-select').val();
  var dataTypeSelect = $('#js-data-type-select');

  dataTypeSelect.val('');

  if(value) {
    dataTypeSelect.prop('disabled', false);
    dataTypeSelect.find('option').prop('disabled', false);

    if(value == 'client') {
      dataTypeSelect.find('option[value="vaccine"]').prop('disabled', true);
    } else if(value == 'pet') {
      dataTypeSelect.find('option[value="address"]').prop('disabled', true);
      
    }

  } else {
    dataTypeSelect.prop('disabled', true);
  }

  dataTypeSelect.selectpicker("refresh");
}

function displayOptions() {
    if (
      $("#js-data-type-select option:selected").val() == "multiple_option" ||
      $("#js-data-type-select option:selected").val() == "single_option"
    ) {
      $("#js-field-options").slideDown("fast");
    } else {
      $("#js-field-options").slideUp("fast");
    }
}